module.exports = __webpack_public_path__ + "static/og-image-cd16586eda78b5625953fb5d42857fba.png";